import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewCustomContentHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Custom Content</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 1 minute to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the "Custom Content " link. This will take you to the Custom Content Listing Page.   <br />
                                    <img src="/img/documentation-img/CCImg/nav.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Custom Content Listing Page, click on any custom content listing of your choice. This will take you to the View Custom Content Details. <br />
                                    <img src="/img/documentation-img/CCImg/list_select.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    In Custom Content Page, you will be able to see the following fields:                                <ul class="unorderedList">
                                        <li>
                                            ID
                                        </li>
                                        <li>
                                            Status
                                        </li>
                                        <li>
                                            Title
                                        </li>
                                        <li>
                                            Page Code
                                        </li>
                                        <li>
                                            Page Type
                                        </li>
                                        <li>
                                            Content
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Content should be in HTML format.
                                </div>
                            </li>

                            </ol>
                            <div className="text-right">
                                <a href="/documentation/customcontent/ViewCustomContentHelp" className="btn btn-primary">View Custom Content &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}